import { http } from "@/api/common";

export default {
  async authenticate(idToken) {
    return http.post("/auth", undefined, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
  },
};
